import { render, staticRenderFns } from "./TrapDetail.vue?vue&type=template&id=71c67396&scoped=true&"
import script from "./TrapDetail.vue?vue&type=script&lang=js&"
export * from "./TrapDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c67396",
  null
  
)

export default component.exports